import '../css/terms.css';